<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <div style="padding-bottom: 5rem">
        <div style="padding:0">
          <!--banner-->
          <div style="width:100%;" v-if="videoInfo.videoUrl!=''">
            <iframe frameborder="0" :src="videoInfo.videoUrl" allowFullScreen="true" style="width:100%;height: 15rem;"></iframe>
          </div>
          <div style="width:21.4375rem;margin: 0 auto;" class="clear_both">
            <div v-html="videoInfo.videoDetail"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,loginInfo,severUrl, } from '@/router/Constant'
  import { getVideoInfo } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {Image,Button,Swipe,SwipeItem,Dialog } from 'vant';
  import {Overlay,PullRefresh,Toast,Tab, Tabs,Tag } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';
  import datePicker from '@/components/page/common/Datepicker.vue';

  export default {
    name: 'classItemInfo',
    data() {
      return {
        token:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        totalPrices:0,
        showLoading:false,
        showCoupons:false,
        nextStepLoading:false,
        emptyCart:false,
        totalPrice:0,
        hotelInfo:[],
        currentContent:"所以这里要放什么呢，暂时不知道",
        productId:this.$route.query.productId,
        storeId:this.$route.query.productStoreId,
        externalLoginKey:getStore("externalLoginKey"),
        typeId:this.$route.query.typeId,
        videoId:this.$route.query.videoId,
        videoInfo:{}
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Dialog.name]: Dialog,
      [Tag.name]: Tag,
      footerView,
      loading,
      refresh,
      datePicker,
    },
    methods: {
      async initData() {
        this.getVideoInfo()
      },

      getVideoInfo(){
        var param = {
          typeId:this.typeId,
          videoId:this.videoId
        }
        getVideoInfo(param)
          .then(res => {
            console.log("getVideoDetail")
            console.log(res)
            this.videoInfo = res.videoDetail
          })
          .catch(err => {
            console.log(err);
          });
      },

    },
    mounted() {
      this.initData();
    },

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 0.6rem;
    background-color: #f4f4f4;
  }

  .content_item {
    background-color: white;padding: 0.3rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 18rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  /*商品活动/优惠券*/
  .goods-action-activity-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: none;
    z-index: 99;
  }
  .goods-action-activity-content{
    width:100%;
    height:30.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    padding-bottom: 1rem;
    z-index: 99;
  }
  .goods-action-activity-title{
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size:1rem;
    color:#333312;
  }
  .goods-action-activity-content-bottom{
    width:21.4375rem;
    margin:0 auto;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-activity-content-name{
    font-size:1rem;
    color:#333312;
    height: 3rem;
    line-height: 3rem;
  }
  .goods-action-activity-content-list{
    width:100%;
  }
  .goods-action-activity-content-each{
    width:100%;
    height: 6.875rem;
    margin-bottom: 0.3125rem;
  }
  .goods-action-activity-content-each img{
    width:100%;
    height: 100%;
  }
  .goods-action-activity-content-list-left{
    display: inline-block;
    vertical-align: top;
    width:2rem;
  }
  .goods-action-activity-content-list-left img{
    width:1.25rem;
    height:0.90625rem;
  }
  .goods-action-activity-content-list-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.5rem);
  }
  .goods-action-activity-content-each-left{
    display: inline-block;
    vertical-align: top;
    width:5rem;
    position: relative;
    top: -5rem;
    left: 2.4rem;
  }
  .goods-action-activity-price{
    color:white;
    font-size: 1.71875rem;
  }
  .goods-action-activity-content-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 5rem);
    position:relative;
    top: -8rem;
    left: 8rem;
  }
  .goods-action-activity-content-desc{
    color:#EB84AB;
    font-size:0.9375rem;
    margin-bottom: 0.6875rem;
  }
  .goods-action-activity-content-time{
    color:#666;
    font-size:0.625rem;
    margin-bottom: 0.96875rem;
  }
  .goods-action-activity-content-status{
    width:100%;
    height: 1.40625rem;
  }
  .goods-action-activity-content-status-desc{
    color:#999;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width: 7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    height: 1.40625rem;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button{
    width:4.6875rem;
    height: 1.40625rem;
    display: inline-block;
    vertical-align: top;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button button{
    width:100%;
    font-size: 0.75rem;
    color:#EB84AB;
    text-align: center;
    line-height: 1.40625rem;
    border-radius:0.703125rem;
    border:1px solid #EB84AB;
  }
  .goods-action-activity-desc{
    color:#EB84AB;
    font-size:1rem;
  }
  .goods-action-activity-time{
    font-size:0.875rem;
    color:#999;
    line-height: 2rem;
  }

  .coupon_item {
    height: 7rem;
  }

  .span_type_item {
    border: 1px solid #E5E5E5;padding: 0.2rem 0.7rem;margin: 0 0.5rem 0 0;border-radius: 0.7rem;
  }

  .span_type_item_active {
    border: 1px solid #D7508D;color: #D7508D;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/mengwa/classItemInfo.vue